export default {
    "平台名称": "платформа баз данных наблюдения для региона Центральной Азии и Западной Азии",
    "平台介绍": " представление",
    "数据集": "набор данных",
    "合作单位": "кооперативная организация",
    "联系我们": "связаться с нами",
    "首页": "Первая страница",
    "元数据": "Метаданные",
    "返回首页": "возвращение",
    "样例": "образец",
    "详细情况": "подробности",

    "管理编号": "номер управления",
    "产生方式": "способ возникновения",
    "空间范围": "пространственный диапазон",
    "时间范围": "временной интервал",
    "学科分类": "классификация дисциплин",

    "数据内容描述": "описание содержимого данных",
    "关键词": "ключевые слова",
    "数据信息": "Информация о данных",

    "数据量": "количество данных",
    "数据记录数": "количество записей данных",
    "更新版本": "Обновить версию",
    "数据生产者": "Источник данных",
    "请联系": "производитель данных",

    "致谢": "Благодарность：При поддержке Стратегического ведущего научно-технического проекта Китайской академии наук (№ XDA20020101)",
    "中心": "Научно-исследовательский центр экологии и окружающей среды Центральной Азии Китайской академии наук (НИЦЭОС ЦА)",
    "中心2": "Научно-исследователъский центр экологии и окружающей среды Централъной Азии (Душанбе) ",
    "联系邮箱": "Техническая поддержка: lijin@ms.xjb.ac.cn"
}
